import {
  createBrowserRouter,
} from "react-router-dom";
import HomePage from "./Pages/HomePage";
import ProductPage from "./Pages/ProductPage";
import StorefrontLoginPage from "./Pages/StorefrontLoginPage";
import Layout from "./Pages/Layout";
import StorefrontTokenPage from "./Pages/StorefrontTokenPage";
import StorefrontLoginConfirmPage from "./Pages/StorefrontLoginConfirmPage";
import CartPage from "./Pages/CartPage";
import OrderPage from "./Pages/OrderPage";
import SearchPage from "./Pages/SearchPage";
import AccountDetailsPage from "./Pages/AccountDetailsPage";
import BundlePage from "./Pages/BundlePage";
import OrderProcessingPage from "./Pages/OrderProcessingPage";
import OrderCompletePage from "./Pages/OrderCompletePage";
import StorefrontGenericLoginPage from "./Pages/StorefrontGenericLoginPage";
import NotFoundPage from "./Pages/NotFoundPage";
import SavedSearchProductPage from "./Pages/SavedSearchProductPage";
import SignupPage from "./Pages/SignupPage";
import PreparedCartPage from "./Pages/PreparedCartPage";
import CartDetailsPage from "./Pages/CartDetailsPage";
import OrderPrerequisitesPage from "./Pages/OrderPrerequisitesPage";

export const router = createBrowserRouter([
  {
    path: "",
    element: <Layout />,
    children: [
      {
        path: '',
        element: <HomePage />,
      },
      {
        path: '/home',
        element: <HomePage />,
      },
      {
        path: '/search',
        element: <SearchPage />
      },
      {
        path: '/products/:productId',
        element: <ProductPage />
      },
      {
        path: '/dynamicProducts/:savedSearchId',
        element: <SavedSearchProductPage />
      },
      {
        path: '/bundles/:bundleId',
        element: <BundlePage />
      },
      {
        path: '/cart',
        element: <CartPage />
      },
      {
        path: '/carts',
        element: <CartDetailsPage />
      },
      { 
        path: '/checkout/:orderId',
        element: <OrderPage />
      },
      {
        path: '/checkoutPrerequisites/:orderId',
        element: <OrderPrerequisitesPage />
      },
      {
        path: '/account',
        element: <AccountDetailsPage />
      },
      {
        path: '/order-processing',
        element: <OrderProcessingPage />
      },
      {
        path: '/order-complete',
        element: <OrderCompletePage />,
      },
      {
        path: '/prepared-cart/:cartId',
        element: <PreparedCartPage />,
      },
      // Custom pages (additional homepages at /{slug}). MUST stay last so every concrete route
      // above wins; a single-segment slug reaches HomePage, which resolves it via findPageBySlug
      // and renders NotFound for an unknown/disabled slug. Multi-segment unmatched paths still fall
      // through to the top-level '*' NotFound route (this dynamic segment matches one segment only).
      {
        path: ':pageSlug',
        element: <HomePage />,
      }
    ]
  },
  {
    path: '/:organization/:storefront/signup',
    element: <SignupPage/>,
  },
  {
    path: '/:organization/:storefront/login',
    element: <StorefrontLoginPage />
  },
  {
    path: '/login',
    element: <StorefrontGenericLoginPage />
  },
  {
    path: '/token',
    element: <StorefrontTokenPage />
  },
  {
    // Where the emailed link lands for the 'poll' login method: confirms the sign-in for the tab
    // that's waiting rather than signing in here.
    path: '/confirm',
    element: <StorefrontLoginConfirmPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
]);
